import axios from 'axios';
import { API_BASE_URL, API_BASE_URL_NEW } from '../../config';
import { refreshAccessToken, getRefreshToken, clearTokens } from './refreshToken';

const apiRequest = async (endpoint, method, data = null, requiresAuth = false, setIsAuthenticated=null, navigate=null, returnsFile=false, isNewApi=false, options = {}) => {
  const { headers = {}, isRetry = false } = options;
  try {
    const base_url = isNewApi ? API_BASE_URL_NEW : API_BASE_URL;
    const url = `${base_url}${endpoint}`;
    const config = {
      method,
      url,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      data,
      responseType: returnsFile ? 'blob' : 'json'
    };

    if (requiresAuth) {
      const token = localStorage.getItem('access_token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      } else {
        setIsAuthenticated(false);
        navigate('/sign-in');
        return;
      }
    }

    const response = await axios(config);
    return returnsFile ? response: response.data;
  }
  catch (error) {
    if (error.response) {
      // Handle specific response status errors
      if (requiresAuth && error.response.status === 401) {
        // The access token has expired. Swap it for a fresh one and replay
        // the request once. isRetry guards against looping if the retry
        // itself comes back 401.
        if (!isRetry && getRefreshToken()) {
          try {
            await refreshAccessToken();
            return await apiRequest(
              endpoint, method, data, requiresAuth, setIsAuthenticated,
              navigate, returnsFile, isNewApi, { ...options, isRetry: true }
            );
          } catch (refreshError) {
            // Refresh failed, so the session is genuinely over. Fall through
            // to the sign-out below.
          }
        }

        setIsAuthenticated(false);
        clearTokens();
        navigate('/sign-in');
      }
    } else {
      console.error('Request failed:', error);
    }
    throw error;
  }
};

export default apiRequest;
